import React, {useEffect, useState} from 'react';
import { Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';
import SkillsArnold from './SkillsArnold';
import SkillTab from './SkillsTab';
import '../modal.css';
import './SkillsInfoModal.css'
const ContactInfoModal = (props) => {
    const [showSkillTab, setShowSkillTab] = useState("original");


  return (
    <>
      {/* <Button variant="primary" onClick={() => setShow(true)}>
        Custom Width Modal
      </Button> */}

      <Modal
        show={props.show}
        size="lg"
        onHide={props.onHide}
        dialogClassName="modal-90w"
        scrollable
        className="PersonalInfoModal-class"
        aria-labelledby="example-custom-modal-styling-title"
        // style={{ overflow: 'auto'}}
        // aria-labelledby="example-modal-sizes-title-lg"
      >
        {/* <Modal.Dialog scrollable 
      className='PersonalInfoModalDiagram-class' */}

        {/* > */}
        <Modal.Header
          className="modal-header"
          style={{ height: "13vh" }}
          closeButton
        >
          <Modal.Title
            id="skillsInfoModal-title"
            style={{ width: "100%", textAlign: "center" }}
          >
            <strong>
              <p>
                {" "}
                Its Me Mario! 
                <br />
                Just Kidding! Its still me, Rakib
              </p>
            </strong>
            {/* <p> Just Kidding! Its still me, Rakib</p> */}
          </Modal.Title>
        </Modal.Header>

        <Modal.Body className="SkillsInfoModalBody-class">
          <div className="skillsInfo-wrapper">
            <SkillTab skillTab={showSkillTab} />
            <SkillsArnold setSkillTab={setShowSkillTab} />
          </div>
        </Modal.Body>
        <Modal.Footer className="modal-footer">
          <div className="modal-got-it-btn-div">
            <Button onClick={props.onHide}>GOT IT!</Button>
          </div>
          {/* <button  onClick={props.onHide}>CLOSE</button> */}
        </Modal.Footer>
        {/* </Modal.Dialog> */}
      </Modal>
    </>
  );
}

export default ContactInfoModal;